import React, { useCallback, useEffect, useState } from "react";
import { Box, Button, CircularProgress } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useNavigate } from "react-router-dom";
import { usePageTracking } from "utils/userPageTracking";

import styles from "./capabilities.module.css";
import OvelContainerWrapper from "./components/OvelContainerWrapper";
import LeftSideGrid from "./components/LeftSideGrid";
import RightSideGrid from "./components/RightSideGrid";
import Controller from "./components/Controller";

import { CAROUSEL_SLIDES } from "./carouselSlides";
// import TrainingIcon from "../../../assets/images/training-icon.png";
import HandbookIcon from "../../../assets/images/handbook-icon.png";

export const ArrowIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.0002 0.00039C24.6162 0.00039 31.6002 6.98439 31.6002 15.6004C31.6002 24.2164 24.6162 31.2004 16.0002 31.2004C7.38419 31.2004 0.400192 24.2164 0.400192 15.6004C0.400192 6.98439 7.38419 0.00039 16.0002 0.00039ZM9.15219 14.7524C8.92749 14.9774 8.80119 15.2824 8.80119 15.6004C8.80119 15.9184 8.92749 16.2234 9.15219 16.4484L13.9522 21.2484C14.0621 21.3663 14.1945 21.4609 14.3417 21.5264C14.4889 21.592 14.6478 21.6273 14.809 21.6301C14.9701 21.633 15.1301 21.6033 15.2795 21.543C15.429 21.4826 15.5647 21.3928 15.6787 21.2789C15.7926 21.1649 15.8824 21.0292 15.9428 20.8797C16.0031 20.7303 16.0328 20.5703 16.0299 20.4092C16.0271 20.248 15.9918 20.0891 15.9262 19.9419C15.8607 19.7947 15.7661 19.6623 15.6482 19.5524L12.8962 16.8004H22.0002C22.3185 16.8004 22.6237 16.674 22.8487 16.4489C23.0738 16.2239 23.2002 15.9187 23.2002 15.6004C23.2002 15.2821 23.0738 14.9769 22.8487 14.7519C22.6237 14.5268 22.3185 14.4004 22.0002 14.4004H12.8962L15.6482 11.6484C15.8602 11.4209 15.9756 11.12 15.9701 10.8092C15.9646 10.4983 15.8386 10.2017 15.6188 9.98183C15.3989 9.76193 15.1023 9.63599 14.7914 9.63047C14.4805 9.62495 14.1797 9.74039 13.9522 9.95239L9.15219 14.7524Z"
      fill="url(#gradient-left)"
    />
    <defs>
      <linearGradient
        id="gradient-left"
        x1="16"
        y1="0"
        x2="16"
        y2="31.2"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFEC9A" />
        <stop offset="1" stopColor="#00B2FF" />
      </linearGradient>
    </defs>
  </svg>
);

const Capabilities = () => {
  const totalSlides = CAROUSEL_SLIDES.length;
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isTrainingLoading, setIsTrainingLoading] = useState(false);
  const [trackedPageName, setTrackedPageName] = useState("");
  const navigate = useNavigate();

  usePageTracking(trackedPageName);

  const safeSlideIndex = Math.min(currentSlide, Math.max(0, totalSlides - 1));
  const slide = totalSlides > 0 ? CAROUSEL_SLIDES[safeSlideIndex] : null;

  const leftTiles = slide?.leftTiles;
  const rightTiles = slide?.rightTiles;

  const handlePrevious = () =>
    setCurrentSlide((prev) => (prev > 0 ? prev - 1 : prev));

  const handleNext = () =>
    setCurrentSlide((prev) => (prev < totalSlides - 1 ? prev + 1 : prev));

  const handleHandbookClick = useCallback(() => {
    setTrackedPageName("Handbook");
  }, []);

  useEffect(() => {
    if (trackedPageName === "Handbook") {
      navigate("/handbook");
    }
  }, [trackedPageName, navigate]);

  return (
    <Box className={styles.capabilities}>
      {/* Logo */}
      <Box className={styles.logo}>
        <img
          src="/assets/Logo.png"
          width={140}
          height={80}
          alt="Unilever logo"
        />
      </Box>
      <Box className={styles.buttonsContainer}>
        <Button
          variant="outlined"
          className={styles.buttonWrapper}
          sx={{
            borderRadius: "75px",
            border: "1.33px solid #FFFFFF33",
            color: "#fff",
            textTransform: "none",
            padding: "10px 10px",
            marginRight: "8px",
          }}
          startIcon={
            <Box
              component={"img"}
              src={HandbookIcon}
              sx={{ width: 20, height: 20 }}
            />
          }
          endIcon={
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                transform: "rotate(135deg)",
              }}
            >
              <ArrowIcon />
            </Box>
          }
          onClick={handleHandbookClick}
        >
          HandBook
        </Button>
        {/* <Button
          variant="outlined"
          className={styles.buttonWrapper}
          sx={{
            borderRadius: "75px",
            border: "1.33px solid #FFFFFF33",
            color: "#fff",
            padding: "10px 10px",
            textTransform: "none",
            "&.Mui-disabled": {
              color: "#fff",
              opacity: 0.75,
            },
          }}
          startIcon={
            <Box
              component={"img"}
              src={TrainingIcon}
              sx={{ width: 20, height: 20 }}
            />
          }
          endIcon={
            isTrainingLoading ? (
              <CircularProgress
                size={18}
                thickness={5}
                sx={{ color: "#fff" }}
              />
            ) : (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  transform: "rotate(135deg)",
                }}
              >
                <ArrowIcon />
              </Box>
            )
          }
          onClick={openLearningHub}
          disabled={isTrainingLoading}
        >
          {isTrainingLoading ? "Checking..." : "Training"}
        </Button> */}
      </Box>

      {/* Main content inside your existing wrapper */}
      <OvelContainerWrapper>
        <Grid
          container
          justifyContent="space-between"
          alignItems="center"
          className={styles.innerGrid}
        >
          {/* Left grid */}
          <Grid size={{ xs: 12, sm: 6, md: 5 }} className={styles.leftGrid}>
            <LeftSideGrid tiles={leftTiles} />
          </Grid>

          {/* Center – smart logo & heading */}
          <Grid
            size={{ xs: 12, sm: 6, md: 2 }}
            className={styles.centerContent}
            onClick={() => navigate("/samarth/dashboard")}
          >
            <div className={styles.imageWrapper}>
              <img
                src="/assets/capability/smarth-logo.png"
                alt="Smart logo"
                className={styles.smartLogo}
                width={200}
              />
              <Box className={styles.imageOverlay} />
            </div>

            <h3 className={styles.title}>
              Supply Chain
              <br />
              Command Centre
            </h3>
          </Grid>

          {/* Right grid */}
          <Grid size={{ xs: 12, sm: 6, md: 5 }} className={styles.rightGrid}>
            <RightSideGrid tiles={rightTiles} />
          </Grid>
        </Grid>

        {/* Carousel controller */}
        <Box className={styles.controllerWrapper}>
          <Controller
            totalSlides={totalSlides}
            currentSlide={safeSlideIndex}
            onPrevious={handlePrevious}
            onNext={handleNext}
          />
        </Box>
      </OvelContainerWrapper>

      {/* <HomeButton /> */}
    </Box>
  );
};

export default Capabilities;
